

export default {
    getFilteredSubKategori : (state) => (id) => state.subKategoriList.filter(v => v.kategori.id === id),
}
